var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 6.1875V11.8125L9 14.625L4.21875 11.8125V6.1875L9 3.375L13.7812 6.1875ZM8.84925 9.22894L8.40488 9.49163L9.23512 9.9765L9.67669 9.71606L10.8574 10.4107L9.09619 11.4457L5.44275 9.31612L5.42756 10.3528L9.09844 12.4847L12.6253 10.4107L10.5587 9.19463L10.9749 8.94881L10.1447 8.46394L9.73125 8.70806L9.15188 8.36719L9.65869 8.06738L8.82844 7.58194L8.32388 7.88006L7.33725 7.29956L9.09787 6.264L11.5324 7.68656L12.4245 7.15894L9.09619 5.22506L5.56931 7.29956L7.44187 8.4015L7.08863 8.60962L7.91887 9.09506L8.26931 8.88806L8.84925 9.22894Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIost);
export default __webpack_public_path__ + "static/media/iost.3975595fb37a7f72e2bcef2334ba5d7d.svg";
export { ForwardRef as ReactComponent };